/**
 * Hostel data configuration for NIVA
 * Gender-based hostel assignment for room delivery
 *
 * Boys:  Ganga, Brahmaputra, Vedhavathi, Teesta
 * Girls: Krishna, Yamuna, Godavari, Narmada, Saraswathi
 */

export const MALE_HOSTELS = [
  'Ganga',
  'Brahmaputra',
  'Vedhavathi',
  'Teesta',
];

export const FEMALE_HOSTELS = [
  'Krishna',
  'Yamuna',
  'Godavari',
  'Narmada',
  'Saraswathi',
];

/**
 * Get hostels based on gender selection
 * @param {'male' | 'female'} gender
 * @returns {string[]} Array of hostel names
 */
export const getHostelsByGender = (gender) => {
  if (gender === 'male') return MALE_HOSTELS;
  if (gender === 'female') return FEMALE_HOSTELS;
  return [];
};

/**
 * Validate hostel selection matches gender
 * @param {string} gender
 * @param {string} hostelName
 * @returns {boolean}
 */
export const isValidHostelForGender = (gender, hostelName) => {
  const hostels = getHostelsByGender(gender);
  return hostels.includes(hostelName);
};

export default {
  MALE_HOSTELS,
  FEMALE_HOSTELS,
  getHostelsByGender,
  isValidHostelForGender
};
